import * as types from 'ducks/types'
import { ActionType, Reducer } from 'ducks/common'

import { AudioConfigsType } from 'app/types'

type StateType = {
    audioConfigs: AudioConfigsType
    userPreferences: {
        s2tBanner: boolean
        t2sBanner: boolean
        speakerId: string | null
        micId: string | null
        voiceoverInDoc: boolean
        s2tAvatar: boolean
        t2sAvatar: boolean
    }
}

const initUserPreferences = (): StateType['userPreferences'] => ({
    s2tBanner: localStorage.s2tBanner ? JSON.parse(localStorage.s2tBanner) : true,
    t2sBanner: localStorage.t2sBanner ? JSON.parse(localStorage.t2sBanner) : true,
    speakerId: localStorage.getItem('speakerId'),
    micId: localStorage.getItem('micId'),
    voiceoverInDoc: localStorage.voiceoverInDoc ? JSON.parse(localStorage.voiceoverInDoc) : true,
    s2tAvatar: localStorage.s2tAvatar ? JSON.parse(localStorage.s2tAvatar) : true,
    t2sAvatar: localStorage.t2sAvatar ? JSON.parse(localStorage.t2sAvatar) : true
})

const initialState: StateType = {
    audioConfigs: {
        s2t: { maxDuration: 0 },
        speakers: [],
        t2s: { maxChars: 0 }
    },
    userPreferences: initUserPreferences()
}

export const configsReducer: Reducer<StateType> = (
    state = initialState,
    action: ActionType
): StateType => {
    switch (action.type) {
        case types.SET_AUDIO_CONFIGS: {
            return { ...state, audioConfigs: action.payload }
        }

        case types.SET_USER_PREFERENCES: {
            return { ...state, userPreferences: initUserPreferences() }
        }

        default: {
            return state
        }
    }
}
